import { SearchParams } from '@/types/common'
import { queryStringify } from '@/ultils'

import {
  IInterfaceSensorData,
  IInterfaceSensorUpdate,
  IPayloadAddInterfaceSensor,
  IPayloadRemoveInterfaceSensor,
} from '@/types/interfaceSensor'
import axiosClient from '../axiosClient'

const ROOT_PATH = `/api/v2/sensor`

const interfaceSensorConfig = {
  getInterfaceSensorData(interfaceId: number, sensorId: string) {
    const url = `${ROOT_PATH}/${interfaceId}/${sensorId}`
    return axiosClient.get<IInterfaceSensorData>(url)
  },

  updateInterfaceSensor(payload: IInterfaceSensorUpdate) {
    const { interfaceId, sensorId, ...rest } = payload
    const url = `${ROOT_PATH}/${interfaceId}/${sensorId}`
    return axiosClient.put(url, rest)
  },
  getListByInterfaceId(interfaceId: number, searchParams: SearchParams = {}) {
    const url = `${ROOT_PATH}/${interfaceId}`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getAllByInterfaceId(interfaceId: number) {
    return this.getListByInterfaceId(interfaceId, {
      PageSize: 99999,
      PageIndex: 1,
    }).then((r) => r.data)
  },

  batchAddInterfaceSensor(payload: IPayloadAddInterfaceSensor) {
    const url = `${ROOT_PATH}/${payload.interfaceId}/batch`
    return axiosClient.post(url, payload)
  },

  batchRemoveInterfaceSensor(payload: IPayloadRemoveInterfaceSensor) {
    const url = `${ROOT_PATH}/${payload.interfaceId}/batch`
    return axiosClient.delete(url, { data: payload })
  },

  syncAsset(): Promise<void> {
    return axiosClient
      .post(`${ROOT_PATH}/syncAsset`, {})
      .then((res) => res.data)
  },
}

export default interfaceSensorConfig
